export enum SectionId {
  Freedom = 'freedom',
  Comfort = 'comfort',
  Development = 'development',
  Montage = 'montage',
  Calculator = 'calculator',
}
